<template>
  <div>
    <div v-show="hasPermission(['IU CONTRALOR VIEW'])">
      <pdf-viewer />
      <invoice-alert />
      <send-invoices />
      <add-shelter-fee v-model="addModal" :title="$t('add') | capitalize" :clients="clients" :periods="periodListSelect"
        @submit="createShelterFee" />

      <vx-card noShadow ref="filterCard" :title="$t('filters')" class="user-list-filters mb-8">
        <template slot="actions">
          <feather-icon icon="FilterIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="search" />
          <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
            @click="resetFilters" />
        </template>
        <div class="vx-row mx-2">
          <div class="vx-col md:w-1/2 w-full">
            <label class="text-sm opacity-75">{{ $t('client') }}</label>
            <v-select multiple :options="clients" v-model="client_id" label="ClientName" :reduce="el => el.ClientId"
              name="filterClient" />
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <label class="text-sm opacity-75">{{ $t("year") }} - {{ $t("week") }}</label>
            <v-select multiple :options="periodListSelect" v-model="period_id" :reduce="el => el.PeriodId"
              label="WeekInvoice" name="filterWeek" />
          </div>
        </div>
      </vx-card>
      <vx-card noShadow>
     <vs-row vs-type="flex" vs-justify="space-between" class="mb-4" vs-w="12">
  <!-- Columna izquierda con los dos botones -->
  <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" class="px-2" vs-xs="12" vs-sm="4" vs-lg="3">
    <vs-button color="success" icon="add" class="mr-2" @click="add">
      {{ $t('add') | capitalize }}
    </vs-button>
    <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-download" @click="handleExport">
      {{ $t('export') | capitalize }}
    </vs-button>
  </vs-col>

  <!-- Columna derecha con la barra de búsqueda -->
  <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" class="px-2" vs-xs="12" vs-sm="6" vs-lg="3">
    <vs-input icon="search" :placeholder="$t('search')" class="w-full" v-model="searchValue"
      @keyup.enter="search()" />
  </vs-col>
</vs-row>

        <invoice-table :ClientId="client_id" :PeriodId="period_id" :searchValue="searchValue" :reSearch="reSearch"
          :sort="sort" :sortBy="sortBy" />
      </vx-card>
    </div>
  </div>
</template>

<script>
//import moduleInvoice from '@/store/invoice/moduleInvoice.js'
import InvoiceTable from '@/views/apps/invoices/components/InvoiceTable.vue'
import InvoiceAlert from '@/views/apps/invoices/components/InvoiceAlert.vue'
import vSelect from 'vue-select'
import client from '@/http/requests/client'
import invoice from '@/http/requests/invoice'
import PdfViewer from '@/components/pdf/PdfViewer.vue'
import moduleInvoice from '@/store/invoice/moduleInvoice.js'
import sendInvoices from '@/views/apps/invoices/components/SendInvoice.vue'
import AddShelterFee from '@/views/apps/invoices/components/AddShelterFee.vue'
import { BASE_URL } from '@/urls.js'
export default {
  components: {
    InvoiceTable,
    InvoiceAlert,
    vSelect,
    PdfViewer,
    sendInvoices,
    AddShelterFee
  },
  data() {
    return {
      sort: ['DESC'],
      sortBy: ['p.Year'],
      modal: false,
      clients: [],
      periodListSelect: [],
      invoices: [],
      searchValue: '',
      reSearch: 1,
      client_id: null,
      period_id: null,
      addModal: false,
    }
  },
  computed: {
    invoiceList() {
      return this.$store.state.invoice.invoiceList
    },
    allowed_to_see_module() {
      const allowed = localStorage.getItem('permissions').includes('IU CONTRALOR VIEW')
      return allowed
    }
  },
  created() {
    if (!moduleInvoice.isRegistered) {
      this.$store.registerModule('invoice', moduleInvoice)
      moduleInvoice.isRegistered = true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      client.list().then(res => {
        this.clients = res.data.clients
      })
      invoice.getPeriodList().then(res => {
        this.periodListSelect = res.data.periodList
      })
    },
    search() {
      this.topTableScroll()
      if (this.client_id != null && this.client_id.length != 0) {
        this.sortBy = ['p.Year', 'p.Week']
        this.sort = ['desc', 'desc']
      }
      if (this.period_id != null && this.period_id.length != 0) {
        this.sortBy = ['cl.ClientName']
        this.sort = ['ASC']
      }

      this.reSearch = this.reSearch + 1
    },
    resetFilters() {
      this.period_id = null
      this.client_id = null
      this.search()
    },
    topTableScroll() {
      const elemento = document.getElementsByClassName('vs-con-tbody vs-table--tbody')
      elemento[0].scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    add() {
      this.addModal = true
    },
    handleExport(){
          this.search()
          const params = new URLSearchParams()
          if(this.client_id != null && this.client_id.length != 0){
            const clients = this.client_id
            clients.forEach(id => params.append('ClientId[]', id))
          }
          if (this.period_id != null && this.period_id.length != 0) {
            const periods = this.period_id
            periods.forEach(id => params.append('PeriodId[]', id))
          }
          if(this.searchValue != ''){
            params.append('search', this.searchValue)
          }
          const url = BASE_URL + `internal_api/contralor/export/WIkshig94wk92i66199aslh84gnuxy94i2yh?` + params.toString()
          window.open(url)
    },
    createShelterFee(data) {
      this.addModal = false
      const formData = new FormData()
      formData.append('addExpenses', data.addExpenses)
      formData.append('client_id', data.clientId)
      formData.append('period_id', data.periodId)
      formData.append('hours', data.hours)
      if(data.documents.length > 0){
      formData.append('document', data.documents[0])
      }

      this.$vs.loading({
        container: '#invoice-list-loading',
        scale: 0.6
      })
      invoice.createShelterFeeManual(formData)
        .then((res) => {
          this.$vs.loading.close('#invoice-list-loading > .con-vs-loading')
           this.$vs.notify({
              color: 'success',
              title: this.$i18n.messages[this.$i18n.locale].success,
              text: this.$i18n.messages[this.$i18n.locale].message_save,
            })
          this.search()
        })
        .catch(err => {
          this.$vs.loading.close('#invoice-list-loading > .con-vs-loading')
          this.$vs.notify({
              color: 'warning',
              title: this.$i18n.messages[this.$i18n.locale].attention,
              text: this.$i18n.messages[this.$i18n.locale].message_error,
            })
        })

    }
  }
}
</script>

<style></style>
